/* eslint-disable no-unused-vars */
import { closeDataUri } from '../images/index';

export default {
  options: {
    style: {},
    stateStyles: {
      hover: {},
      selected: {},
    },
  },
  /**
   * 获取形状的大小
   */
  getSize(cfg = { size: [] }) {
    const { size } = cfg;
    if (typeof size === 'string' || typeof size === 'number') {
      return {
        width: size * 1,
        height: size * 1,
      };
    }

    if (Array.isArray(size)) {
      const [width = 0, height = 0] = size;
      return {
        width,
        height,
      };
    }

    return {
      width: 0,
      height: 0,
    };
  },
  /**
   * 绘制节点，包含文本
   * @param  {Object} cfg 节点的配置项
   * @param  {G.Group} group 图形分组，节点中图形对象的容器
   * @return {G.Shape} 返回一个绘制的图形作为 keyShape，通过 node.get('keyShape') 可以获取。
   * 关于 keyShape 可参考文档 核心概念-节点/边/Combo-图形 Shape 与 keyShape
   */
  draw(cfg, group) {
    const { height } = this.getSize(cfg);
    const fontSize = 12; // 文本大小
    const padding = 10; // 边距
    const closeSize = 18; // 关闭按钮大小
    const fixedWidth = 60; // 固定宽度

    console.log('cfgcfg', cfg);
    const defaultProps = {
      group: cfg.group,
      id: cfg.id,
      label: cfg.label,
    };

    // 文字
    const text = group.addShape('text', {
      attrs: {
        textBaseline: 'center',
        textAlign: 'left',
        fontSize: 12,
        x: padding,
        y: fontSize + (fontSize / 2),
        text: cfg.label,
        lineHeight: 1,
        fill: '#000',
        ...defaultProps,
      },
      draggable: true,
    });

    const labelBox = text.getBBox();

    let ellipsis = false;

    if (labelBox.width > fixedWidth) {
      text.attrs.text = `${cfg.label.substring(0, 4)}...`;
      ellipsis = true;
      text.attrs.ellipsis = true;
    }

    const shape = group.addShape('rect', {
      draggable: true,
      attrs: {
        x: 0,
        y: 0,
        // width: labelBox.width + padding + closeSize + (padding / 2), // 自动适应宽度
        width: fixedWidth + padding + closeSize + (padding / 2), // 固定宽度
        height,
        fill: cfg.style.fill, // 填充色
        stroke: '', // 边框
        radius: 3,
        ...defaultProps,
        ellipsis,
      },
      linkPoints: cfg.linkPoints,
    });

    // 新增图片
    const close = group.addShape('image', {
      attrs: {
        width: closeSize,
        height: closeSize,
        img: closeDataUri,
        y: (height / 2) - (closeSize / 2),
        // x: labelBox.width + padding, // 自适应宽度
        x: fixedWidth + padding, // 固定宽度
        cursor: 'pointer',
        ...defaultProps,
        ellipsis: false,
      },
      name: 'close',
      draggable: true,
    });

    text.toFront();
    close.toFront();

    return group;
  },
  /**
   * 绘制后的附加操作，默认没有任何操作
   * @param  {Object} cfg 节点的配置项
   * @param  {G.Group} group 图形分组，节点中图形对象的容器
   */
  // afterDraw(cfg, group) { },
  /**
   * 更新节点，包含文本
   * @override
   * @param  {Object} cfg 节点的配置项
   * @param  {Node} node 节点
   */
  // update(cfg, node) { },
  /**
   * 更新节点后的操作，一般同 afterDraw 配合使用
   * @override
   * @param  {Object} cfg 节点的配置项
   * @param  {Node} node 节点
   */
  // afterUpdate(cfg, node) { },
  /**
   * 响应节点的状态变化。
   * 在需要使用动画来响应状态变化时需要被复写，其他样式的响应参见下文提及的 [配置状态样式] 文档
   * @param  {String} name 状态名称
   * @param  {Object} value 状态值
   * @param  {Node} node 节点
   */
  // setState(name, value, node) { },
  /**
   * 获取锚点（相关边的连入点）
   * @param  {Object} cfg 节点的配置项
   * @return {Array|null} 锚点（相关边的连入点）的数组,如果为 null，则没有控制点
   */
  getAnchorPoints(cfg) {
    // return cfg.linkPoints;
  },
};
